/**
 * Утилита для миграции старых данных корзины
 */

import { consola } from 'consola'
import type { CartItem } from '~/utils/types/cart';

const logger = consola.withTag('cart-migrate')

/**
 * Проверить является ли элемент старым комбо (legacy)
 */
export function isLegacyCombo(item: any): boolean {
  return !!(item.combo_id && !item.itemType);
}

/**
 * Очистить старые комбо из localStorage
 *
 * Используется при обнаружении несовместимых данных
 */
export function clearLegacyCombosFromStorage(): number {
  try {
    const cartStr = localStorage.getItem('cart');
    if (!cartStr) return 0;

    const cart = JSON.parse(cartStr);
    if (!Array.isArray(cart)) return 0;

    const legacyCombos = cart.filter(isLegacyCombo);
    const cleanCart = cart.filter((item: any) => !isLegacyCombo(item));

    if (legacyCombos.length > 0) {
      logger.warn('🧹 Clearing legacy combos from localStorage:', {
        count: legacyCombos.length,
        items: legacyCombos.map((c: any) => c.name),
      });

      localStorage.setItem('cart', JSON.stringify(cleanCart));
    }

    return legacyCombos.length;
  } catch (error) {
    logger.error('Error clearing legacy combos:', error);
    return 0;
  }
}

/**
 * Проверить и очистить корзину от несовместимых данных
 */
export function cleanupCart(items: CartItem[]): CartItem[] {
  return items.filter((item: any) => {
    // Удаляем старые комбо
    if (isLegacyCombo(item)) {
      logger.warn('⚠️ Removing legacy combo:', item.name);
      return false;
    }
    return true;
  });
}

/**
 * Попытаться мигрировать старое комбо в новый формат
 * (НЕ ПОДДЕРЖИВАЕТСЯ - комбо нужно добавлять заново)
 */
export function migrateComboToNewFormat(legacyCombo: any): null {
  logger.warn('⚠️ Cannot migrate legacy combo to new format:', legacyCombo.name);
  logger.warn('Please re-add the combo using the new combo selection interface');
  return null;
}


